import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { DataGrid } from '@mui/x-data-grid';

const useStyles = makeStyles((theme) => ({
	header: { fontSize: '1.05rem' },
}));

function UserSelections({ users, handleUserSelectionChange, selectedUserIds, ...rest }) {
	const classes = useStyles();
	const columns = React.useMemo(() => {
		const commonColSettings = {
			headerClassName: classes.header,
		};

		return [
			{
				...commonColSettings,
				field: 'id',
				headerName: 'User ID',
				display: 'flex',
				filterable: false,
				sortable: true,
				width: 100,
				valueGetter: (value) => {
					return `${value}`;
				},
			},
			{
				...commonColSettings,
				field: 'email',
				headerName: 'Email',
				display: 'flex',
				filterable: true,
				sortable: true,
				width: 200,
				// flex: 1,
				// valueGetter: (value) => {
				// 	return `${value}`;
				// },
			},
			{
				...commonColSettings,
				field: 'company',
				headerName: 'Company',
				display: 'flex',
				filterable: true,
				sortable: true,
				// resizable: true,
				width: 200,
				// maxWidth: 300,
				// flex: 1,
			},
			{
				...commonColSettings,
				field: 'userGroups',
				headerName: 'User Groups',
				display: 'flex',
				filterable: true,
				sortable: true,
				flex: 1,
				valueGetter: (value) => {
					return value.map((ug) => ug.name).join(', ');
				},
			},
		];
	}, [classes.header]);
	const autosizeOptions = {
		includeHeaders: false,
		columns: ['company', 'userGroups'],
	};

	return (
		<DataGrid
			// autoHeight
			// autoPageSize
			// sx={{
			// 	'& .MuiDataGrid-cell': { display: 'inline-block' },
			// }}
			density="compact"
			autosizeOptions={autosizeOptions}
			disableRowSelectionOnClick
			rows={users}
			columns={columns}
			initialState={{
				pagination: {
					paginationModel: { page: 0, pageSize: 10 },
				},
			}}
			pageSizeOptions={[5, 10, 20, 50, 100]}
			checkboxSelection
			onRowSelectionModelChange={(newRowSelectionModel) => {
				handleUserSelectionChange(newRowSelectionModel);
			}}
			rowSelectionModel={selectedUserIds}
			getRowHeight={() => 'auto'}
		/>
	);
}

UserSelections.propTypes = {
	users: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			company: PropTypes.string.isRequired,
			userGroups: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.string.isRequired,
					name: PropTypes.string.isRequired,
				})
			).isRequired,
		})
	).isRequired,
	selectedUserIds: PropTypes.arrayOf(PropTypes.string).isRequired,
	handleUserSelectionChange: PropTypes.func.isRequired,
};

UserSelections.defaultProps = {};

export default UserSelections;
